import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'wsb-rich-sms-details',
  templateUrl: './rich-sms-details.component.html',
  styleUrls: ['./rich-sms-details.component.scss'],
  standalone: false
})
export class RichSmsDetailsComponent implements OnInit {
  uuidMessage: string;

  activeId = 1;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params.uuid) {
        this.uuidMessage = params.uuid;
      }
    });
  }

  goBack() {
    window.history.back();
  }
}
